import { render, staticRenderFns } from "./DadosClientePanel.vue?vue&type=template&id=4f22a21b&"
import script from "./DadosClientePanel.vue?vue&type=script&lang=js&"
export * from "./DadosClientePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports